import { render, staticRenderFns } from "./Science-personnel.vue?vue&type=template&id=4ce311d0&scoped=true&"
import script from "./Science-personnel.vue?vue&type=script&lang=js&"
export * from "./Science-personnel.vue?vue&type=script&lang=js&"
import style0 from "./Science-personnel.vue?vue&type=style&index=0&id=4ce311d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce311d0",
  null
  
)

export default component.exports